module.exports = __webpack_public_path__ + "img/1920_icon_red_checked.4632a6ab.svg";